import { Card, Flex, Space } from 'antd'
import dayjs from 'dayjs'
import { useParams } from 'react-router-dom'

import {
  GetSimeTbTreatmentPlanResponse,
  GetTreatmentPlanResponse,
  QrCodeType
} from 'src/api/requests'
import { QRCode, Text } from 'src/components'
import { dayMonthYearHourMinutesFormatSeparator } from 'src/libs'
import { useLocales } from 'src/locales'

import { useStyles } from './styles'
import { TreatmentStatusTag } from './TreatmentStatusTag'

type Props = {
  data?: GetTreatmentPlanResponse | GetSimeTbTreatmentPlanResponse
}

export const TreatmentHeader = ({ data }: Props) => {
  const { t } = useLocales()
  const { personId } = useParams()

  const { styles } = useStyles()

  return (
    <Flex gap={16}>
      <Card className={styles.headerCard}>
        <Flex vertical gap={8} className="full-width">
          <Flex justify="space-between">
            <Space>
              <Text weight={400}>{t('stock_applications.request_date')}:</Text>
              <Text strong>
                {dayjs(data?.created).format(
                  dayMonthYearHourMinutesFormatSeparator
                )}
              </Text>
            </Space>

            <TreatmentStatusTag status={data?.status} />
          </Flex>
        </Flex>
      </Card>
      <Card
        styles={{
          body: {
            padding: 16
          }
        }}
      >
        <QRCode
          type={QrCodeType.TREATMENT}
          content={`${personId} ${data?.id}`}
        />
      </Card>
    </Flex>
  )
}
